/**
 * @description This is data Util will use for Data Transformation
 * @param Array<object>  it will take array as object and remove key 'q' data from it.
 * @returns Object without key 'q'
 * */
import AppUtils from "./AppUtils";

const removeQ = (objectData: any) => {
        if (AppUtils.isDefined(objectData) && Array.isArray(objectData) && objectData.length > 0) {
            objectData.forEach((ele: any) => {
                // Nested Q Remove START
                  // For Nested Check of the element if Q finds Delete it else it will go to Catch
                // const qElementList =  ;
               ele && ele.items && ele.items.length > 0 && ele.items.forEach((element: any) => {
                    delete element.q
                });
                // Nested Q Remove START
                if(ele)
                delete ele.q      // Removing Key from the object.
            })
        }
        return objectData     //Returning Object as it is with transformation and removing Q if Found

    }

export default removeQ


